import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/(auth)/register/page.tsx");
